module.exports = __webpack_public_path__ + "media/application/images/icons/play-button-large-933f5f52c20bdfdf97a32325c2588c0a.svg";